// extracted by mini-css-extract-plugin
module.exports = {"privacy-policy":"privacy_privacy-policy__OoYJq"};